import { Formik } from "formik";
import { Avatar } from "./avatar";
import { UploadImages } from "./uploadImages"

export const ProfileEdit = ({type}) =>{
 
    let user = {name:'tester', bio:'bio'}
    return  <div className="create-page">
        
        <Formik
                initialValues={{ name: user.name, bio: user.bio,'avatar':'/assets/images/faces/default.svg' }}
                onSubmit={(values, { setSubmitting }) => {
                   setTimeout(() => {
                        setSubmitting(false);
                   }, 100);
                }}
                >
                {({
                    values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit, isSubmitting, 
                }) => (
                    <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-6">
                            <label htmlFor="">Name</label>
                            <input 
                                type="text" 
                                name="name" 
                                placeholder="username"  
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                            />
                        </div>
                        {errors.name && touched.name ? <div>{errors.name}</div> : null}

                        <div className="col-6">
                            <label htmlFor="">Category</label>
                             {/** 
                              <SelectSearch
                                options={[]}
                                getOptions={(query) => {
                                    return []; new Promise((resolve, reject) => {
                                        fetch(`https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${query}`)
                                            .then(response => response.json())
                                            .then(({ drinks }) => {
                                                resolve(drinks?.map(({ idDrink, strDrink }) => ({ value: idDrink, name: strDrink }))||[])
                                            })
                                            .catch(reject);
                                    });
                                }}
                                search
                                placeholder="Select"
                            />                              
                              **/}
                        </div>
                    
                        <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="">Bio</label>
                                <textarea 
                                    name="bio" 
                                    placeholder="About"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.bio}
                                >{values.bio}</textarea>
                                <small className="">Introduce yourself</small>
                            </div>
                            {errors.bio && touched.bio ? <div>{errors.bio}</div> : null}
                        </div>
                    
                        
                        <div className="col-4 ">
                        <Avatar source={user.avatar} />
                        </div>

                        
                        <div className="col-12">
                                <div className="form-group">
                                    <button 
                                        type="submit" 
                                        disabled={isSubmitting} 
                                        className="float-right btn btn-primary col-3" >
                                        Create
                                    </button>
                                </div>
                        </div>

                        <UploadImages />
                                
                        <div className="profile_component">
                          {/* <ChooseComponent type={type} /> */}
                        </div>
        
                    </div>
                    </form>
                )}
        </Formik>
      
      
       </div> 
}
 
